import React from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import Select from 'react-select';

const stateOptions = [
  { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
  { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
  { value: 'Assam', label: 'Assam' },
  { value: 'Bihar', label: 'Bihar' },
  { value: 'Chhattisgarh', label: 'Chhattisgarh' },
  { value: 'Goa', label: 'Goa' },
  { value: 'Gujarat', label: 'Gujarat' },
  { value: 'Haryana', label: 'Haryana' },
  { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
  { value: 'Jharkhand', label: 'Jharkhand' },
  { value: 'Karnataka', label: 'Karnataka' },
  { value: 'Kerala', label: 'Kerala' },
  { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
  { value: 'Maharashtra', label: 'Maharashtra' },
  { value: 'Manipur', label: 'Manipur' },
  { value: 'Meghalaya', label: 'Meghalaya' },
  { value: 'Mizoram', label: 'Mizoram' },
  { value: 'Nagaland', label: 'Nagaland' },
  { value: 'Odisha', label: 'Odisha' },
  { value: 'Punjab', label: 'Punjab' },
  { value: 'Rajasthan', label: 'Rajasthan' },
  { value: 'Sikkim', label: 'Sikkim' },
  { value: 'Tamil Nadu', label: 'Tamil Nadu' },
  { value: 'Telangana', label: 'Telangana' },
  { value: 'Tripura', label: 'Tripura' },
  { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
  { value: 'Uttarakhand', label: 'Uttarakhand' },
  { value: 'West Bengal', label: 'West Bengal' },
  { value: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands' },
  { value: 'Chandigarh', label: 'Chandigarh' },
  { value: 'Dadra and Nagar Haveli and Daman and Diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
  { value: 'Lakshadweep', label: 'Lakshadweep' },
  { value: 'Delhi', label: 'Delhi' },
  { value: 'Puducherry', label: 'Puducherry' },
];

const countryOptions = [
  { value: 'India', label: 'India' }
];

const AddressForm = () => {
  const { setFieldValue, values } = useFormikContext();

  return (
    <>    

      <div className="mb-3">
        <label htmlFor="emailid">Email</label>
        <Field id="emailid" name="emailid" type="email" 
        className="form-control form-control-sm" />
        <ErrorMessage name="emailid" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="website">Website</label>
        <Field id="website" name="website" className="form-control form-control-sm" />
        <ErrorMessage name="website" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="address">Address</label>
        <Field id="address" component="textarea"
        name="address" className="form-control form-control-sm"
        rows="4"
         />
        <ErrorMessage name="address" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="state">State</label>
        <Select
          id="state"
          name="state"
          options={stateOptions}
          value={stateOptions.find(o => o.value === values.state)}
          onChange={opt => setFieldValue('state', opt.value)}
          classNamePrefix="react-select"
        />
        <ErrorMessage name="state" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="city">City</label>
        <Field id="city" name="city" className="form-control form-control-sm" />
        <ErrorMessage name="city" component="div" className="text-danger small" />
      </div>
     
      <div className="mb-3">
        <label htmlFor="postalCode">Postal Code</label>
        <Field id="postalCode" name="postalCode" className="form-control form-control-sm"
        inputMode="numeric"
            maxLength="6"
            onInput={e => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
         />
        <ErrorMessage name="postalCode" component="div" className="text-danger small" />
      </div>

      <div className="mb-3">
        <label htmlFor="country">Country</label>
        <Select
          id="country"
          name="country"
          options={countryOptions}
          
          value={countryOptions.find(o => o.value === values.country)}
          onChange={opt => setFieldValue('country', opt.value)}
          classNamePrefix="react-select"
        />
        <ErrorMessage name="country" component="div" className="text-danger small" />
      </div>
    </>
  );
};

export default AddressForm;
